// extracted by mini-css-extract-plugin
export default {"content":"_404_content__kxNJ2"};